module.exports = __webpack_public_path__ + "img/logo.3735f023.png";